import { RequestCategory } from '@atlassian/notification-types/types';
import { messages } from '../../../index';
export var resolveCategoryMessage = function resolveCategoryMessage(category) {
  switch (category) {
    case RequestCategory.DIRECT:
      return messages.direct;
    case RequestCategory.NONE:
      return messages.watching;
    // This also handles the unused RequestCategory.ANY
    default:
      return messages.direct;
  }
};